export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=0050f87180c105923b2894fa71008a8027821b8067&name=getWishlistServerAction!'